import { render, staticRenderFns } from "./fullscreen-btn.vue?vue&type=template&id=c3060e1a&"
import script from "./fullscreen-btn.vue?vue&type=script&lang=js&"
export * from "./fullscreen-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports